import http from "../http-common";

class ClientDataService{
	getFields(){
		return http.get('/client-fields');
	}
	createField(data){
		return http.post('/client-fields', data);
	}
	updateField(id, data){
		return http.put(`/client-fields/${id}`, data);
	}
	deleteField(id){
		return http.delete(`/client-fields/${id}`);
	}
	getClients() {
    	return http.get('/clients');
  	}
  	createClient(data) {
  		console.log('estoy creando client', data);
    	return http.post('/clients', data);
  	}
  	updateFieldOrder(fields) {
    	return http.post('/client-fields', { fields });
  	}
  	updateClient(id, data) {
  		return http.put(`/clients/${id}`, data);
	}
	getClient(id) {
		return http.get(`/clients/${id}`);
	}
	uploadPhoto(id, file) {
		const formData = new FormData();
		formData.append('photo', file);
		return http.post(`/clients/${id}/photo`, formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
	}
	removePhoto(id) {
		return http.delete(`/clients/${id}/photo`);
	}
	deleteClient(id) {
  		return http.delete(`/clients/${id}`);
	}

}


export default new ClientDataService();